import React from 'react';

const links = [
  { label: 'Features', href: '#features' },
  { label: 'The lookup', href: '#lookup' },
  { label: 'Screens', href: '#screens' },
  { label: 'Languages', href: '#languages' },
  { label: 'Compare', href: '#compare' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Status', href: '#status' },
];

const external = [
  { label: 'Dictionary catalogue', href: 'https://lexeme.uk/dictionaries/catalog.json' },
  { label: 'Dictionary licence', href: 'https://lexeme.uk/dictionaries/LICENSE.txt' },
];

/** Low-contrast closing strip — the colophon, not another call to action. */
const SiteFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-ink/15 bg-surface py-10">
      <div className="shell">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="display-sm text-xl">Lexeme</p>
            <p className="prose-note mt-1.5 text-[0.875rem]">
              A Saar Labs project. Personal, offline, and not released.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="font-body text-[0.8125rem] text-muted transition hover:text-primary"
              >
                {link.label}
              </a>
            ))}
            {external.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-[0.8125rem] text-muted underline decoration-secondary/30 underline-offset-4 transition hover:text-primary"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <p className="mt-8 border-t border-ink/12 pt-6 font-body text-[0.75rem] text-muted">
          © {year} Saar Labs · lexeme.uk · Dictionary data from Wiktionary (kaikki.org) and FreeDict
          under CC BY-SA · Books from Project Gutenberg
        </p>
      </div>
    </footer>
  );
};

export default SiteFooter;
